<template>
  <div>
    <div class="container-fluid bg-light py-6 mt-0">
      <div class="container text-center animated bounceInDown">
        <h1 class="display-1 mb-4">{{ $t("aboutSchool") }}</h1>
        <ol
          class="breadcrumb justify-content-center mb-0 animated bounceInDown"
        >
          <li class="breadcrumb-item">
            <a href="#">{{ $t("home") }}</a>
          </li>
          <li class="breadcrumb-item">
            <a href="#">{{ $t("aboutSchool") }}</a>
          </li>
          <li class="breadcrumb-item text-dark" aria-current="page">
            {{ $t("schoolHistory") }}
          </li>
        </ol>
      </div>
    </div>
    <div class="container">
      <div class="row g-5 mt-3 p-1">
        <div class="col-lg-5 wow bounceInUp" data-wow-delay="0.1s">
          <img src="img/aboutus.jpg" class="img-fluid rounded" alt="" />
        </div>
        <div class="col-lg-7 wow bounceInUp" data-wow-delay="0.3s">
          <small
            class="d-inline-block fw-bold text-dark text-uppercase bg-light border border-primary rounded-pill px-4 py-1 mb-3"
            >{{ $t("aboutSchool") }}</small
          >
          <h1 class="display-5 mb-4">{{ $t("aboutTitle") }}</h1>
          <p class="mb-4">
            {{ $t("aboutPara") }}
          </p>
          <p>
            {{ $t("aboutDetailOne") }}
          </p>
          <p>
            {{ $t("aboutDetailTwo") }}
          </p>
          <div class="row g-4 text-dark mb-5">
            <div class="col-sm-6">
              <i class="fas fa-share text-primary me-2"></i
              >{{ $t("aboutFactOne") }}
            </div>
            <div class="col-sm-6">
              <i class="fas fa-share text-primary me-2"></i
              >{{ $t("aboutFactTwo") }}
            </div>
            <div class="col-sm-6">
              <i class="fas fa-share text-primary me-2"></i
              >{{ $t("aboutFactThree") }}
            </div>
            <div class="col-sm-6">
              <i class="fas fa-share text-primary me-2"></i
              >{{ $t("aboutFactFour") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <Team></Team>
  </div>
</template>

<script>
import Team from "../components/Team.vue";
export default {
  components: {
    Team,
  },
};
</script>

<style></style>
